const scriptLoads = new Map()

// Share both pending and completed loads across components and Gatsby routes.
export const loadExternalScript = (source, { id, ready } = {}) => {
  if (typeof document === "undefined") {
    return Promise.reject(new Error("Scripts can only load in the browser."))
  }
  if (ready && ready()) return Promise.resolve()

  const url = new URL(source, document.baseURI).href
  if (scriptLoads.has(url)) return scriptLoads.get(url)

  let script = Array.from(document.scripts).find((item) => item.src === url)
  const ownsScript = !script
  if (!script) {
    script = document.createElement("script")
    script.src = url
    script.async = true
    script.defer = true
    if (id) script.id = id
  }

  const promise = new Promise((resolve, reject) => {
    let readinessCheck
    const cleanUp = () => {
      clearTimeout(timeout)
      clearInterval(readinessCheck)
      script.removeEventListener("load", onLoad)
      script.removeEventListener("error", onError)
    }
    const finish = () => {
      cleanUp()
      resolve()
    }
    const onError = () => {
      cleanUp()
      if (ownsScript) script.remove()
      reject(
        new Error(`Unable to load a script from ${new URL(url).hostname}.`)
      )
    }
    const onLoad = () => {
      script.dataset.expendLoaded = "true"
      if (!ready || ready()) {
        finish()
      } else {
        // reCAPTCHA's API script loads another script before render is ready.
        readinessCheck = setInterval(() => {
          if (ready()) finish()
        }, 50)
      }
    }
    const timeout = setTimeout(onError, 30000)

    script.addEventListener("load", onLoad)
    script.addEventListener("error", onError)
    if (script.dataset.expendLoaded === "true") onLoad()
    else if (ownsScript) (document.body || document.head).appendChild(script)
  })

  scriptLoads.set(url, promise)
  promise.catch(() => {
    // A later mount or an explicit retry can try a failed request again.
    if (scriptLoads.get(url) === promise) scriptLoads.delete(url)
  })
  return promise
}
